import * as React from "react";

import { NotificationsContext } from ".";

export const useNotifications = () => {
    const context = React.useContext(NotificationsContext);
    if (!context) {
        throw new Error(
            "attempting to useNotifications outside of a NotificationsProvider"
        );
    }

    return context;
};
